<template>
  <div>
    <div class="recommendPage">
      <swiper class="swipers" :options="swiperOption" ref="mySwiper">
        <swiper-slide>
          <img class="banner" src="../../static/image/swiper.png" alt="" />
        </swiper-slide>
        <swiper-slide>
          <img class="banner" src="../../static/image/swiper.png" alt="" />
        </swiper-slide>
        <div class="swiper-pagination" slot="pagination"></div>
        <div class="swiper-button-prev" slot="button-prev"></div>
        <div class="swiper-button-next" slot="button-next"></div>
      </swiper>
    </div>

    
    <div class="kpDiv">
      <img src="../../static/image/kp1.png" alt="" />
      <img src="../../static/image/kp2.png" alt="" />
      <img src="../../static/image/kp3.png" alt="" />
      <img src="../../static/image/kp4.png" alt="" />
      <img src="../../static/image/kp6.png" alt="" />
      <div  class="footer">
        <div class="ghDiv">
          <img class="ghImg" src="../../static/image/gh.png" alt="" :style="{width: isMobile ? '15px' : '25px'}" />
          <a href="https://beian.miit.gov.cn/#/Integrated/index" :style="{fontSize: isMobile ? '8px' : '14px'}">京ICP备2026000484号-1</a>
        </div>
        <img src="../../static/image/footer.png" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
// 引入插件
import { swiper, swiperSlide } from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";

export default {
  components: {
    swiper,
    swiperSlide,
  },
  data() {
    return {
      swiperOption: {
        loop: true,
        autoplay: {
          delay: 3000,
          stopOnLastSlide: false,
          disableOnInteraction: false,
        },
        // 显示分页
        pagination: {
          el: ".swiper-pagination",
          clickable: true, //允许分页点击跳转
        },
        // 设置点击箭头
        navigation: {
          // 用样式隐藏了左右切换的箭头
          // nextEl: null,
          // prevEl: null
        },
      },
    };
  },
  
  computed: {
    swiper() {
      return this.$refs.mySwiper.swiper;
    },
     isMobile() {
      return this.$store.state.isMobile
    }
  },
  mounted() {
    // current swiper instance
    // 然后你就可以使用当前上下文内的swiper对象去做你想做的事了
    console.log("this is current swiper instance object", this.swiper);
    // this.swiper.slideTo(3, 1000, false);
  },
};
</script>

<style scoped>
.recommendPage .swiper-container {
  position: relative;
  width: 100%;
  /* height: 720px; */
  /* background: pink; */
}
.recommendPage .swiper-container .swiper-slide {
  width: 100%;
  /* line-height: 730px; */
  /* background: yellowgreen; */
  color: #000;
  font-size: 16px;
  text-align: center;
}
.swiper-button-prev {
  display: none !important;
}
.swiper-button-next {
  display: none !important;
}
.banner {
  width: 100%;
  /* height: 730px; */
}
</style>
<style scoped lang="scss">
.kpDiv {
  display: flex;
  flex-direction: column;
  img {
    width: 100%;    
    max-width: 100%;
    height: auto;  
  }
}
</style>
